var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"terms-link",attrs:{"href":"/agb.html","target":"_blank","rel":"noopener noreferrer"},on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.linkText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }